import { FC } from "react";

import { Stack, Typography } from "@mui/material";

import { ReduxHiddenDataField } from "../../../../../components/Redux/ReduxHiddenDataField";
import {
  getRouteFormProperty,
  setRouteFormError,
  setRouteFormProperty,
} from "../../../../../slices/routes";
import { validateK8sServiceAccountToken } from "../../../../../validators/url";
import CodeSnippet from "@/components/CodeSnippet";

export const ServiceAccountToken: FC = () => {
  return (
    <Stack direction={"column"} spacing={2} className="max-w-2xl">
      <Typography>
        Use the command below to obtain the service account token created in the
        previous step, then paste it here.
      </Typography>
      <CodeSnippet
        code={`kubectl -n pomerium-zero get secret pomerium-impersonate-token -o=template='{{.data.token | base64decode}}{{"\\n"}}'`}
        copyInfo="kubectl_command"
      />
      <ReduxHiddenDataField
        path="kubernetesServiceAccountToken"
        setter={setRouteFormProperty}
        getter={getRouteFormProperty}
        errorHandler={setRouteFormError}
        validator={validateK8sServiceAccountToken}
        spellCheck={false}
      />
    </Stack>
  );
};
